import { gql } from '@apollo/client';

export const MCreateJiraBug = gql`
  mutation CreateJiraBug(
    $projectNumber: String!
    $risque: String!
    $viewLabel: String!
    $viewId: String!
    $url: String!
    $environment: String!
    $title: String!
    $description: String
    $projectData: JSON
    $clientName: String
    $board: String!
    $boardUrl: String!
    $priority: String!
    $jiraEnvironment: String!
  ) {
    createJiraBug(
      projectNumber: $projectNumber
      risque: $risque
      viewLabel: $viewLabel
      viewId: $viewId
      url: $url
      environment: $environment
      title: $title
      description: $description
      projectData: $projectData
      clientName: $clientName
      board: $board
      boardUrl: $boardUrl
      priority: $priority
      jiraEnvironment: $jiraEnvironment
    ) {
      ok
      error
      issueKey
      issueUrl
    }
  }
`;
